import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { titleCase } from "title-case";
import Stack from "@mui/material/Stack";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { jwtDecode } from "jwt-decode";
import "./breadcrumbs.scss";

/** "active-sprints" -> "Active Sprints"; the URL itself is untouched. */
const prettify = (segment) => {
  let text = segment;
  try {
    text = decodeURIComponent(segment);
  } catch (error) {
    text = segment;
  }
  return titleCase(text.replace(/[-_]+/g, " ").trim());
};

const BreadcrumbsComponent = () => {
  const location = useLocation();
  const navigation = useNavigate();
  const pathArray = location.pathname.split("/");

  const navigate = useNavigate();
  let currentLink = "";

  const token = localStorage.getItem("accessToken");
  let role = "user";
  if (token) {
    const decodedToken = jwtDecode(token);
    if (decodedToken.email === "sushmitha.gopari@motivitylabs.com") {
      // navigate("/admin/dashboard");
      role = "admin";
    } else {
      // navigate("/projects");
      role = "user";
    }
  }

  const crumbSegments = pathArray.filter((crumbs) => crumbs !== "");

  const breadcrumbs = crumbSegments.map((eachPath, index) => {
      currentLink += `/${eachPath}`;
      const isCurrent = index === crumbSegments.length - 1;

      if (index === pathArray.length - 2 || index === pathArray.length - 3) {
        return (
          <Typography
            key={index}
            className={`bc-text ${isCurrent ? "bc-current" : ""}`}
            aria-current={isCurrent ? "page" : undefined}
            title={prettify(eachPath)}
          >
            {prettify(eachPath)}
          </Typography>
        );
      }

      return (
        <NavLink
          key={index}
          className={`breadcrumbs-links crumb-class-name bc-link ${isCurrent ? "bc-current" : ""}`}
          aria-current={isCurrent ? "page" : undefined}
          title={prettify(eachPath)}
          to={role !== "admin"?currentLink:'/admin/dashboard'}
        >
          {prettify(eachPath)}
        </NavLink>
      );
    });


  const handleNavigation = () => {
    // const token = localStorage.getItem("accessToken");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        if (decodedToken.email === "sushmitha.gopari@motivitylabs.com") {
          navigate("/admin/dashboard");
        } else {
          navigate("/projects");
        }
      } catch (error) {
        console.error("Invalid token or token decoding failed", error);
      }
    } else {
      // navigate("/login");
    }
  };

  return (
    <>
      <Box className="app-breadcrumbs">
        <Button
          className="bc-back-btn"
          aria-label="Go back"
          // onClick={() => { navigation('/projects') }}
          onClick={handleNavigation}
        >
          <ArrowBackIcon />
        </Button>
        <Stack spacing={1} className="bc-stack pe-3">
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<NavigateNextIcon fontSize="small" />}
            className="d-flex align-items-center"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </Stack>
      </Box>
    </>
  );
};

export default BreadcrumbsComponent;
